const $ = require('jquery');
window.jQuery = $;
window.$ = $;
import './specific/counter.js';
